import { createRouter, createWebHistory } from 'vue-router'
import ReviewYourPurchases from '../components/ReviewYourPurchases.vue'

const routes = [
  {
    path: '/',
    name: 'questionnaire',
    component: ReviewYourPurchases
  },
  {
    path: '/questionnaire',
    name: 'questionnaire-home',
    component: ReviewYourPurchases
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router

